module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Offre_1.9c84b6d4-ps.jpg";